import template from './bCurrencyChange.html';
import moment from "moment";

export function bCurrencyChangeDirective() {
  'ngInject';

  return {
    restrict: 'E',
    template: template,
    controller: bCurrencyChangeController,
    controllerAs: 'bCurrencyChange',
    bindToController: true,
    scope: {
      currencies: "=",
      localCurrency: "=",
      currencyRatio: '='
    }
  };
}

class bCurrencyChangeController {
  constructor($scope, $rootScope, Clients, $q, Auth, Notes, $interval, $translate, bModal, Stats) {
    'ngInject';

    this.$scope = $scope;
    this.Stats = Stats;
    this.currencyModalHidden = true;
    this.today = moment().format('YYYY-MM-DD');
    this.currencyStrategy = '';
    this.disabledApply = false;
    this.isOnModal = false;
    this.Auth = Auth;
    this.$rootScope = $rootScope;
    this.Clients = Clients;
    this.$q = $q;
    this.Notes = Notes;
    this.$interval = $interval;
    this.$translate = $translate;
    this.bModal = bModal;
    this.bmodalOpen = false;
    this.live = this.today;
    this.init();
  }

  init() {

    this.Auth.getCustomSetupExchangeRate().then((customSetupExchangeRate) => {
      this.$rootScope.setupRate = customSetupExchangeRate.data;
    });

    var timeout = this.$interval(() => {
      this.notes = this.Notes.getNotes();
    }, 10);
    this.$scope.$on("$destroy", () => {this.$interval.cancel(timeout);});

    this.currencyStrategy = this.$rootScope.setupRate === undefined ? 'Live' : this.$rootScope.setupRate.currencyStrategy;
    this.date = this.$rootScope.setupRate === undefined ? this.today : this.$rootScope.setupRate.date;

    if (this.currencyStrategy === undefined) {
      this.currencyStrategy = 'Live';
      this.changeDate(this.today);
    }
    if (this.currencyStrategy === "Live") {
      this.changeDate(this.today);
    }
    if (this.currencyStrategy === "FixedDate") {
      this.date = this.$rootScope.setupRate.date;
      this.changeDate(this.date);
    }
    if (this.currencyStrategy === "FixedRate") {
      this.exchangeRate = this.$rootScope.setupRate.rate;
    }

    document.addEventListener("click", ()=>{
      if(!this.isOnModal && !this.bmodalOpen) {
        this.closePopover();
        this.$scope.$digest();
      }
    });
    this.bmodalOpen = false;
  }

  changeDate(date){
    this.disabledApply = true;
    this.setupDate = moment(date).format('YYYY-MM-DD');
    const call = [this.Clients.getCurrenciesDate(this.setupDate)];

    if(this.currencyStrategy === "Live"){
      this.Stats.refreshCurrencyConversions().then((success) => {
        this.currencyRates = success.data;
        this.currencyRate = this.currencyRates[this.localCurrency];
        this.date = this.today;
        this.exchangeRate = this.currencyRate;
      }, () => {
        this.currencyRates = {};
      });
    }

    this.$q.all(call).then(res => {

      const currencies = res[0].data;
      const currencyObject = currencies[this.localCurrency];

      if(currencyObject[0].at !== date && currencyObject.length === 1 && this.currencyStrategy !== "Live" && this.date !== moment().format('YYYY-MM-DD')){
        this.bmodalOpen = true;
        this.modalConfig = {
          text: this.$translate.instant("VIEW360.CURRENCY.QUESTION_PART1") + currencyObject[0].at + this.$translate.instant("VIEW360.CURRENCY.QUESTION_PART2"),
          cancelText: this.$translate.instant("VIEW360.MODAL.NO"),
          acceptText: this.$translate.instant("VIEW360.MODAL.YES"),
          neutral: true
        };

        this.bModal.show(this.modalConfig).then(() => {
          this.setupDate = currencyObject[0].at;
          this.date = currencyObject[0].at;
          this.live = currencyObject[0].at;
          this.exchangeRate = currencyObject[0].rate;
        }, () =>
        {this.disabledApply = true;});
      }

      if(currencyObject.length === 2 && this.currencyStrategy !== "Live"){
        this.bmodalOpen = true;
        this.modalConfig = {
          text: this.$translate.instant("VIEW360.CURRENCY.QUESTION_TWO_DATES_1") + currencyObject[0].at + " and " +  currencyObject[1].at + this.$translate.instant("VIEW360.CURRENCY.QUESTION_TWO_DATES_2"),
          cancelText: currencyObject[0].at,
          acceptText: currencyObject[1].at,
          neutral: true
        };

        this.bModal.show(this.modalConfig).then(() => {
          this.setupDate = currencyObject[1].at;
          this.date = currencyObject[1].at;
          this.exchangeRate = currencyObject[1].rate;
        }, () =>
        { this.setupDate = currencyObject[0].at;
          this.date = currencyObject[0].at;
          this.exchangeRate = currencyObject[0].rate;});
      }

      if(currencyObject.length === 1) this.exchangeRate = currencyObject[0].rate;
      this.disabledApply = false;
    }, (error) => {
      this.Notes.postNote({type: "error", description: "ERROR_LOADING_DATA", error: error, message: error.data.message});
    });
  }

  validate(currency){
    if(currency <= 0 || currency === undefined){
      this.disabledApply = true;
    } else {
      this.exchangeRate = this.exchangeRate.replace(/,/g, '.');
      this.disabledApply = false;
    }
  }

  apply() {
    function setupExchangeRateObject() {
      if (this.currencyStrategy === "Live") {
        this.$rootScope.setupRate = {
          currencyStrategy: "Live",
          date: this.setupDate,
          rate: this.exchangeRate
        };
      }

      if (this.currencyStrategy === "FixedRate") {
        this.$rootScope.setupRate = {
          currencyStrategy: "FixedRate",
          date: this.setupDate,
          rate: this.exchangeRate
        };
      }

      if (this.currencyStrategy === "FixedDate") {
        this.$rootScope.setupRate = {
          currencyStrategy: "FixedDate",
          date: this.setupDate,
          rate: this.exchangeRate
        };
      }
    

    this.currencyModalHidden = true;
    this.currencyRatio = this.exchangeRate;

    // this.Auth.getPreferences().then((preferences) => {
    //   const newPreferences = angular.copy(preferences);
    //   newPreferences['customSetupExchangeRate'] = this.$rootScope.setupRate;
    //   this.Auth.patchPreferences(newPreferences);
    // });

    this.Auth.patchCustomSetupExchangeRate(this.$rootScope.setupRate);  
    }

    setupExchangeRateObject.call(this);

    this.Notes.postNote({
      type: "success",
      message: this.$translate.instant("VIEW360.CURRENCY.APPLIED")
    });
  }

  areNotInEcb(){
    if(['UAH', 'VND', 'KZT'].includes(this.localCurrency)){
        return false;
    } else return true;
  }


  clear() {
    this.init();
  }

  closePopover() {
    this.currencyModalHidden = true;
  }

  togglePopover() {
    this.currencyModalHidden = !this.currencyModalHidden;
  }

  onModal(value) {
    this.isOnModal = value;
  }

}
